<template>
  <!-- 页面容器 -->
  <div class="page-container">
    <!-- 展会信息卡片 -->
    <div class="page-card">
      <!-- 搜索栏 -->
      <div class="page-card__header">
        <span style="font-weight: bold">展会信息</span>
      </div>

      <!-- 数据表格 -->
      <div class="page-card__body">
        <el-table
          :data="tableData"
          style="width: 100%;"
          @row-click="go_detail"
        >
          <el-table-column
            prop="create_time"
            label="上传时间"
            width="200"

            sortable
          >
          </el-table-column>

          <el-table-column
            prop="title"
            label="标题">
          </el-table-column>


        </el-table>
      </div>

      <!-- 分页器 -->
      <div class="pagination-wrap" v-if="tableData.length !== 0">
        <el-pagination
          @current-change="handleCurrentChange"
          :page-size="pagesize"
          :total="aSum"
          :page-count="pageCount"
          :current-page.sync="currentPage"
          background
          layout="prev, pager, next,jumper"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '../../utils/api'

  export default {
    name: "reserveList",
    data() {
      return {
        tableData: [],
        //分页
        // 总条目数 total
        aSum: 0,
        // 当前页数 currenr_page
        currentPage: 1,
        // 总页数 num_pages
        pageCount: 1,
        // 每页显示条目数 pagesize
        pagesize: 10,

      }
    },
    mounted() {
      this.ListData();

    },
    methods: {
      /** 获取展会信息列表 */
      ListData() {
        let url = this.baseUrl + '/user/news/';
        api.fetchData(url).then(res => {
          this.tableData = res.results;
           this.aSum = res.count;
          this.currentPage = 1;
        })


      },
      /** 跳转到资讯详情页 */
      go_detail(row, event, column) {
        this.$router.push({name: 'infoDetail', query: {id: row.id}})

      },

      /** 分页切换 */
      handleCurrentChange(val) {
        let url = this.baseUrl + '/user/news/?page=' + val;
        api.fetchData(url).then(res => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = val;
        })

      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/manage/exhibitionList.vue